import React, { Component } from 'react';
import MultiDropDown from '../MultiDropDown/MultiDropDown';
import CloseUpSVG from '../../svg/CloseUpSVG';
import { withStore } from '../store';
import { Service } from '../ApiService';
import Table from '../Table';
import { Helper } from '../Helper';
import { Link } from 'react-router-dom'
import Loader from '../Loader';

import EditUpSVG from '../../svg/EditUpSVG'

import Alert from '../Alert';

class Services extends Component {

    constructor(props) {
        super(props);
        this.state = {
            serviceList: [],
            loading: false
        };
    }

    getFilters = (props) => {
        let actualFilters = {};
        console.log(props.filters);
        props.filters.forEach(a => {
            if (Array.isArray(a.value) && a.value.length > 0) {
                actualFilters[a.name] = a.value;
            } else if (typeof (a.value) == "string" && a.value != "") {
                actualFilters[a.name] = a.value;
            } else if (a.value instanceof Date && !isNaN(a.value.valueOf())) {
                actualFilters[a.name] = a.value.toISOString().slice(0, 10);
            } else if (typeof (a.value) == "object" && a.value != null) {
                if (a.value.activated) {
                    actualFilters[a.name] = a.value;
                }
            } else if (typeof (a.value) == "number" && a.value != 0) {
                actualFilters[a.name] = a.value;
            } else if (typeof (a.value) == "boolean") {
                actualFilters[a.name] = a.value;
            }
        });
        return actualFilters;
    }

    updateList(props) {
        this.setState({ loading: true }, () => {
            let actualFilters = this.getFilters(props);

            // Service.getFilteredMembers(actualFilters).then(json => { this.setState({ members: json, loadData: false }); });
            Service.getFilteredServiceList(actualFilters).then(data => this.setState({ serviceList: data, loading: false }));
        });
    }

    componentWillReceiveProps(props) {
        let temp = JSON.stringify(props.filters);
        if (temp != this.filtersStr) {
            this.filtersStr = temp;
            this.updateList(props);
        }
    }

    componentDidMount() {
        var component = this;
        this.updateList(this.props);
       // Service.getServiceList().then(data => component.setState({ serviceList: data }));
    }

    renderServiceName(value, row, index, col) {
        return (
            <li key={index} className={col.className ? "table-content-vertical " + col.className : "table-content-vertical"}>
                <div style={{ display: 'flex' }}>
                    <span className='chapter'>{value}</span>
                    <button
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        onClick={() => {
                            this.headerText = 'Warning';
                            this.dialogText = 'You want to remove the Service'
                            this.onOkButtonClick = () => { this.removeService(row); this.setState({ showDialog: false }) };
                            this.cancelButtonText = 'Cancel';
                            this.okButtonText = 'Remove';
                            this.dialogContent = <h4>{value}</h4>
                            this.setState({ showDialog: true })/*this.removeMember(row)*/
                        }}
                    >
                        <CloseUpSVG />
                    </button>
                    <Link
                        className='round-button small-round-button light-grey-outline-button'
                        style={{ "flex": "0 0 1rem", "marginLeft": "0.2em" }}
                        to={'/edit-service/' + row['serviceLineId']}
                    >
                        <EditUpSVG />
                    </Link>
                </div>
                <p className='description-text'>{row.description}</p>
            </li>
        );
    }

    renderPrice(value, row, index, col) {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span className='table-mini-header'>{col.title + ": "}</span><span>{Helper.CurrencyFormat(value)}</span>
            </li>
        );
    }
    
    removeService = (service) => {
        this.setState({ loading: true }, () => {
            //var actualFilters = this.getFilters(this.props);
            Service.deleteService(service)
                .then(data => {
                    setTimeout(() => {
                        this.updateList(this.props);

                        //me.setState({ serviceList: data, loading: false });
                    }, 1000);
                });
        });
    }

    render() {
        const serviceList = this.state.serviceList;//filterList();
        const columns = [
            { title: "Service", accesor: "name", className: "borders-when-display-block", render: this.renderServiceName.bind(this) },
            { title: "One-time Price", accesor: "oneTimePrice", render: this.renderPrice.bind(this) },
            { title: "Daily Price", accesor: "dailyPrice", render: this.renderPrice.bind(this) }
        ];

        return (
            <div className={(!this.props.hideEdit ? 'inner-pages-wrapper' : '') + ' ipw-600'}>
                {this.state.loading && <Loader />}

                {!this.props.hideEdit &&
                    <div className="flex-wrap align-center justify-space-between w-100 mb-2 ">
                        <h1 className='uppercase-text'><strong>Services</strong></h1>
                        <a className='big-static-button static-button' href="/new-service"><p>NEW SERVICE</p></a>
                    </div>
                }
                {this.state.loadData && <Loader />}

                <Table groupProperty='serviceGroup'
                    groupRendeder={(group) => {
                        var rec = this.props.store.serviceGroups.find(e => e.id == group);
                        if (rec) return rec.name;
                        return '';
                    }}
                    columns={columns}
                    data={serviceList}
                    className={"break-at-500"}
                    addHeadersForNarrowScreen={true} />

                {this.state.showDialog &&
                    <Alert
                        headerText={this.headerText}
                        text={this.dialogText}
                        onClose={() => this.setState({ showDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showDialog: false })}
                        onOkButtonClick={this.onOkButtonClick}
                        cancelButtonText={this.cancelButtonText}
                        okButtonText={this.okButtonText}
                        mode='warning'
                    >
                        {this.dialogContent}
                    </Alert>
                }

            </div>
        );
    }
}

export default withStore(Services);


// WEBPACK FOOTER //
// ./src/components/Service/Services.jsx